import Book from "components/svgs/book";
import Apple from "components/svgs/apple";
import Backpacks from "components/svgs/backpacks";
import * as React from 'react';
export default {
  Book,
  Apple,
  Backpacks,
  React
};